module.exports = __webpack_public_path__ + "assets/创新验证.07fcef06.svg";